var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEngland(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8049 19.9999H20.8045C21.5459 19.9999 22.1758 19.7972 22.6989 19.444L14.8049 13.7358V19.9999Z",
    fill: "#2E3192"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4273 16.4593C24.5128 15.997 24.5563 15.5075 24.5563 14.9998V12.7271H19.2654L24.4258 16.4593",
    fill: "#2E3192"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.687194 3.52686C0.598326 4.01046 0.554306 4.50458 0.555953 5.00004V7.27276H5.86711L0.687194 3.52686Z",
    fill: "#2E3192"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3051 0H4.30548C3.56941 0 2.94357 0.2 2.42273 0.548182L10.3051 6.24818V0Z",
    fill: "#2E3192"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.44702 19.4664C2.96299 19.8046 3.58057 20.0001 4.30578 20.0001H10.3054V13.7837L2.44702 19.4664Z",
    fill: "#2E3192"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.555908 12.7271V14.9998C0.555908 15.523 0.601655 16.0271 0.692024 16.5011L5.91131 12.7271H0.555908Z",
    fill: "#2E3192"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7226 0.570454C22.1954 0.207727 21.5568 0 20.8046 0H14.805V6.29591L22.7226 0.570454Z",
    fill: "#2E3192"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5545 7.27252V4.99979C24.5545 4.50252 24.5121 4.02297 24.43 3.56934L19.3093 7.27252H24.5545Z",
    fill: "#2E3192"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3092 7.27273L24.4299 3.56955C24.1952 2.26773 23.6237 1.19 22.7226 0.570454L14.805 6.29591V0H14.0551V8.18182H24.5544V7.27273H19.3092Z",
    fill: "#E6E7E8"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M0.555908 11.8184V12.7275H5.91131L0.692024 16.5015C0.939884 17.7993 1.5286 18.8647 2.44691 19.4665L10.3053 13.7838V20.0002H11.0552V11.8184H0.555908Z",
    fill: "#E6E7E8"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5543 11.8184H14.0549V20.0002H14.8049V13.7361L22.6989 19.4447C23.6067 18.832 24.1853 17.7602 24.4253 16.4602L19.2648 12.7275H24.5543V11.8184Z",
    fill: "#E6E7E8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3053 0V6.24818L2.42291 0.548182C1.51172 1.15727 0.929384 2.22727 0.686775 3.52682L5.86707 7.27273H0.555908V8.18182H11.0552V0H10.3053Z",
    fill: "#E6E7E8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.055 8.18182V0H11.0552V8.18182H0.555908V11.8182H11.0552V20H14.055V11.8182H24.5544V8.18182H14.055Z",
    fill: "#BE1E2D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.78186 7.27249L1.26359 1.83203C1.10197 2.12294 0.972233 2.44294 0.86499 2.78385L7.06972 7.27249H8.78073",
    fill: "#BE1E2D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2132 17.3134L17.9087 12.7271H16.1628L23.7797 18.2811C23.9564 17.9819 24.1019 17.6575 24.2132 17.3152",
    fill: "#BE1E2D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3239 1.08691L14.7932 7.27282L16.5252 7.27419L23.8864 1.93191C23.7221 1.56964 23.5489 1.336 23.3239 1.08691Z",
    fill: "#BE1E2D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1.2356 18.1248C1.40427 18.4362 1.60726 18.7182 1.83893 18.963L10.3288 12.7271H8.61775L1.2356 18.1248Z",
    fill: "#BE1E2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngland);
export default __webpack_public_path__ + "static/media/england.327fcc0a.svg";
export { ForwardRef as ReactComponent };